import {useEffect} from 'react';
import {useIntl} from '@sail/intl';

import {useRetrieveReturnDetailsCollectionSession} from 'src/return/api/useRetrieveReturnDetailsCollectionSession';
import {getStore} from 'src/return/state/store';
import type {ReturnDetailsCollectionSessionCredentials} from 'src/return/state/useReturnDetailsCollectionContext';
import {UserFacingError} from 'src/utils/error';
import messages from 'src/utils/messages';
import {MERCHANT_BRANDING_DEFAULTS} from 'src/v2/util/merchantBrandingDefaults';

export const useStateInitialize = (
  sessionContext: ReturnDetailsCollectionSessionCredentials,
) => {
  const intl = useIntl();
  const store = getStore();
  const {data, error, loading} =
    useRetrieveReturnDetailsCollectionSession(sessionContext);

  useEffect(() => {
    if (!data) {
      return;
    }

    store.setValue((state) => {
      state.cryptocurrency = data.cryptocurrency;
      state.id = data.id;
      state.merchantBranding = {
        buttonColor: data.buttonColor ?? MERCHANT_BRANDING_DEFAULTS.buttonColor,
        merchantName: data.merchantName,
        logo: data.logo,
      };
      state.network = data.network;
      state.state = data.state;
      state.submittedWalletAddress = data.submittedWalletAddress;
    });
  }, [data, store]);

  if (error) {
    throw error;
  }

  if (!loading && !data) {
    throw new UserFacingError(intl.formatMessage(messages.error404));
  }
};
